// Geometry of the 2-seat board-game table (chess, checkers). Table-local,
// floor origin, metres, +Y up — the same frame as every game's furniture
// (see docs/games-contract.md). Seat 0 sits at +Z, seat 1 at −Z, so each
// player has their own side of the board nearest them:
//   square i = rank * 8 + file (a1 = 0); rank 0 is seat 0's back row,
//   file 0 (the a-file) is on seat 0's left.

import { SEAT_Y, TABLE_TOP } from '../tableLayout';
import type { Chair } from '../types';

export { SEAT_Y };
/** Table top surface height (same as the card table). */
export const BT_TOP = TABLE_TOP;
/** Square table width / depth. */
export const BT_W = 0.9;
/** One board square. 8 × 0.07 = 0.56 m board. */
export const SQ = 0.07;
export const BOARD_W = SQ * 8;
/** Board surface (pieces stand on it). */
export const BOARD_Y = BT_TOP + 0.0045;
/** Chair centre distance from the table centre. */
export const CHAIR_D = 0.78;

/** Seat 0 at +Z, seat 1 at −Z, each facing the table (yaw = atan2(-x, -z)). */
export const BOARD_CHAIRS: Chair[] = [
  { x: 0, z: CHAIR_D, yaw: Math.atan2(-0, -CHAIR_D) },
  { x: 0, z: -CHAIR_D, yaw: Math.atan2(-0, CHAIR_D) },
];

/** Pick / select box (table + both chairs). */
export const BOARD_FOOTPRINT = { w: 1.2, d: 2.2 };

/** Table-local XZ of square i's centre. */
export function sqXZ(i: number): [number, number] {
  return [((i & 7) - 3.5) * SQ, (3.5 - (i >> 3)) * SQ];
}

/** Forward (toward the table) and right vectors of a chair's sitter. */
export function chairAxes(ch: Chair) {
  const fx = Math.sin(ch.yaw), fz = Math.cos(ch.yaw);
  return { fx, fz, rx: -fz, rz: fx };
}
